"use strict";

exports.__esModule = true;
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _component = require("../component");

var _Pagination = _interopRequireDefault(require("../Pagination"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getData(data, pager) {
  if (!Array.isArray(data)) return data;
  if (data.length <= pager.pageSize) return data;
  var start = (pager.current - 1) * pager.pageSize;
  return data.slice(start, start + pager.pageSize);
}

function _default(Component) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_PureComponent) {
    _inheritsLoose(_class, _PureComponent);

    function _class(props) {
      var _this;

      _this = _PureComponent.call(this, props) || this;
      var pp = props.pagination;
      _this.state = {
        current: pp.current || pp.defaultCurrent || 1,
        pageSize: pp.pageSize || 10
      };
      _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      return _this;
    }

    var _proto = _class.prototype;

    _proto.getProp = function getProp(key) {
      return this.props.pagination[key] || this.state[key];
    };

    _proto.getPager = function getPager(data, pagination) {
      var loading = this.props.loading;
      var total = Array.isArray(data) ? data.length : 0;
      return Object.assign({
        current: this.getProp('current'),
        pageSize: this.getProp('pageSize'),
        total: total,
        disabled: loading
      }, pagination, {
        onChange: this.handleChange
      });
    };

    _proto.handleChange = function handleChange(current, pageSize) {
      var onChange = this.props.pagination.onChange;
      this.setState({
        current: current,
        pageSize: pageSize
      });
      if (onChange) onChange(current, pageSize);
    };

    _proto.render = function render() {
      var _this$props = this.props,
          pagination = _this$props.pagination,
          data = _this$props.data,
          props = _objectWithoutPropertiesLoose(_this$props, ["pagination", "data"]);

      var pager = this.getPager(data, pagination);
      return [_react.default.createElement(Component, _extends({
        key: "origin",
        data: getData(data, pager)
      }, props)), _react.default.createElement(_Pagination.default, _extends({
        key: "pager"
      }, pager))];
    };

    return _class;
  }(_component.PureComponent), _defineProperty(_class, "propTypes", {
    data: _propTypes.default.any,
    loading: _propTypes.default.bool,
    pagination: _propTypes.default.object.isRequired
  }), _temp;
}